import {Avatar, Button, Typography} from "antd";
import React from "react";
import {useSelector} from "react-redux";
import {handleLogout} from "../../services/Logout";

export const UserHeader = () => {

    const profile = useSelector(state => state.profileData);

    return (
        <div className={'mt-20'} style={{ justifyContent: 'flex-end', display: 'flex', alignItems: 'center' }}>
            <Avatar style={{ backgroundColor: 'blue', verticalAlign: 'middle' }} size="large">
                {profile?.login.slice(0, 2).toUpperCase()}
            </Avatar>
            <Typography.Text style={{ marginLeft: 10, marginRight: 10, verticalAlign: 'middle' }}>
                {profile?.login}
            </Typography.Text>
            <Button
                size="small"
                color="danger" variant="filled"
                onClick={() => handleLogout()}
            >
                Выйти
            </Button>
        </div>
    )
}